<template>
  <div>
    <div class="justify-center d-flex mt-5">
      <div v-if="streamerData">
        <scroll-animation :instant="true" animation-type="zoomIn">
          <v-avatar :image="streamerData.user.profile_pic ?? utils.getImgUrl('user_profile_pic.png')" size="64"/>
          <span class="font-weight-bold ml-5" style="font-size: 24px;">{{streamerData.user.username}}</span>
        </scroll-animation>
      </div>
    </div>
    <v-row v-if="data && data.items.length > 0" class="mt-5 ml-1 mr-1" justify="center" align="center">
      <v-col v-for="(item, index) in data.items" :key="item.id" cols="auto">
        <scroll-animation :delay="200 + index * 100" :instant="true" animation-type="fadeInLeft">
          <public-shop-item :item="item" :settings="settings" :currency="currency"></public-shop-item>
        </scroll-animation>
      </v-col>
    </v-row>
    <div v-else class="text-center pa-10 big-text">
      {{ $t('shop.public.no-items') }}
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Backend } from '@/services/Backend';
import { useRoute } from 'vue-router';
import PublicShopItem from '@/components/PublicShopItem.vue';
import { Kick } from '@/services/Kick';
import ScrollAnimation from '@/components/custom/ScrollAnimation.vue';
import { Stats } from '@/services/Stats';

const route = useRoute();

const data = ref(null);
const settings = ref(null);
const streamerData = ref(null);
const kickletUser = ref(null);
const currency = ref(null);

onMounted(() => {
  const user = route.params.streamer;

  Backend.getUserByKickUsername(user)
    .then(resp => {
      kickletUser.value = resp.data;
      Stats.getPublicCurrencyName(resp.data.kickId)
        .then(resp => {
          currency.value = resp.data.currency;
        });
    });

  Backend.getPublicShopItems(user)
    .then(resp => {
      data.value = resp.data;
    })
    .catch(Backend.handleError);

  Backend.getPublicShopSettings(user)
    .then(resp => {
      settings.value = resp.data;
    })
    .catch(Backend.handleError);

  Kick.getStreamerData(user)
    .then(resp => {
      streamerData.value = resp;
    })
    .catch(Backend.handleError);
});
</script>

<style scoped>

</style>
